<template>
	<section
	class="container-form-parrainage clear-after">

		<p><span class="picto"></span><span class="texte">Parrainer des co-locataires et <br>gagner un mois d'abonnement</span></p>
		<form
		class="clear-after"
		id="form-parrainage"
		action="#"
		method="post"
		accept-charset="UTF-8">
			<div
		class="form-group form-sans-label form-parrainage-email">
				<div>
					<label
					for="form-parrainage-email">Adresse e-mail :</label>
					<input
					type="email"
					id="form-parrainage-email"
					name="parrainageemail"
					placeholder="E-mail"
					v-model="parrainageData.email">
				</div>
			</div>
			<button
			class="button-petit-simple">Envoyer
			</button>
		</form>

		<div id="test-result">
			<div v-if="isSubmitted">
				<hr>
				<div>
					<div class="panel panel-default">
						<div class="panel-heading">
							<h4>The Data</h4>
						</div>
						<div class="panel-body">
							<p>Email parrainage: {{ parrainageData.email }}</p>
							<br>
							<h4>Data récurrentes supplémentaires ?</h4>
							<p>Nombre de Matching: {{ userData.nbrMatching }}</p>
							<p>Nombre de Favoris: {{ userData.nbrFavoris }}</p>
							<br>
							<h4>Data récurrentes</h4>
							<p>Prénom: {{ profilData.prenom }}</p>
							<p>Src de la photo de profil: {{ profilData.SrcPhotoUser }}</p>
							<p>Nombre de nouveaux messages chat: {{ userData.nbrNouveauxMessage }}</p>
							<p>Progress bar: {{ progressBarValeur }}%</p><br>
						</div>
					</div>
				</div>
				<hr><br>
			</div>
		</div>

	</section>
</template>

<script>

export default {
  name: 'dashboard-newsletter',
  data() {
    return {
      user: {
      },
      // Container Data différent pour parrainage ?
      // Peut-être multiple
      parrainageData: {
        email: '',
      },
      isSubmitted: false,
    }
  },
}
</script>
